<template>
  <div  :class="{'radio':!tags&&!tabs,'tags':tags,'tabs':tabs}" :style="{minWidth:width+'px',display:'inline-block'}">
    <input type="radio" :readonly="readonly" :id="randomId" :value="label"s v-model="model" :disabled="disabled">
    <label :for="randomId">
      <slot></slot>
    </label>
  </div>
</template>

<script>
  export default {
    name:"v-radio",
    props:{
      width:{
        default:50
      },
      readonly:{
        type:[String,Number,Boolean]
      },
      label:{
        type:[String,Number,Boolean]
      },
      value: {
        type:[Boolean,String,Number],
        default:false,
      },
      tags: {
        type:Boolean,
        default:false,
      },
      tabs:{
        type:Boolean,
        default:false,
      },
      validate:{
        type:[String,Object]
      },
      disabled:Boolean
    },
    data () {
      return {
        randomId:'radio-' + Math.random(),
        model:this.value
      }
    },
    watch:{
      value:function (val) {
        this.model = val
      },
      model:function (val) {
        this.$emit('input',val)
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '@/assets/css/varible.less';
  .radio>label{
    display: inline-block;
    margin-bottom: 7px;
    margin-right: 10px;
  }
  .radio>input[type="radio"] {
      display: none;
  }
  .radio>input[type="radio"] + label::before {
      content: '';
      font-size: 30px;
      line-height: 10px;
      text-align: center;
      display: inline-block;
      width: 14px;
      height: 14px;
      vertical-align: middle;
      border: 1px solid @blue;
      color: @blue;
      border-radius: 50%;
      margin-right:2px;
  }
  .radio>input[type="radio"]:checked + label::before {
      content: '\2022';
  }
  .radio>input[type="radio"]:checked + label{
      color: @blue
  }
  .radio>input[type="radio"]:disabled + label::before,input[type="radio"]:disabled + label {
      border-color:#888;
      color:#aaa
  }
  .tags>label,.tabs>label{
    display: inline-block;
    padding: 5px;
    &:hover{
      color: @blue
    }
  }
  .tags>input[type="radio"],.tabs>input[type="radio"] {
      display: none;
  }
  .tags>input[type="radio"]:checked + label,.tabs>input[type="radio"]:checked + label{
      color: @blue
  }
  .tabs>input[type="radio"]:checked + label{
    border-bottom: 1px solid @blue;
    position: relative;
    &:after{
      content:'';
      width:0;
      height:0;
      border:8px solid transparent;
      border-top-color: @blue;
      border-bottom-width: 0;
      position: absolute;
      bottom:-8px;
      left:50%;
      margin-left:-8px;
    }
  }

</style>
